/*
 * De omschrijving op een productpagina staat ingeklapt op een paar regels, met de
 * knop "Meer informatie" eronder. Past de tekst binnen die regels, dan is de knop
 * niet nodig en blijft hij weg.
 */
(function () {
  function regel(blok) {
    var tekst = blok.querySelector('[data-km-omschrijving-tekst]');
    var knop = blok.querySelector('[data-km-omschrijving-knop]');
    if (!tekst || !knop) return;

    // Is er meer dan wat je ingeklapt ziet? Dat is zo als er meer dan één alinea is, of
    // als die ene alinea langer is dan de drie regels die te zien zijn.
    var eerste = tekst.firstElementChild;
    var pastNiet = tekst.children.length > 1;
    if (!pastNiet && eerste) pastNiet = eerste.scrollHeight > eerste.clientHeight + 2;
    knop.hidden = !pastNiet;
    blok.classList.toggle('km-omschrijving--kort', !pastNiet);

    if (blok.dataset.kmKlaar === 'ja') return;
    blok.dataset.kmKlaar = 'ja';

    var label = knop.querySelector('[data-km-omschrijving-label]');
    knop.addEventListener('click', function () {
      var open = blok.classList.toggle('is-open');
      knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Lees minder' : 'Lees meer';
    });
  }

  function start() {
    document.querySelectorAll('[data-km-omschrijving]').forEach(regel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Na het laden van de webfonts of bij een andere schermbreedte verandert het aantal
  // regels; dan opnieuw kijken of de knop nodig is.
  window.addEventListener('load', start);
  window.addEventListener('resize', start);
  document.addEventListener('shopify:section:load', start);
})();
